<template>
  <div>
    <Header></Header>
    <div id="main">

      <div class="container">
        <div class="row">
          <h1 class="project-name">{{(project && project.Info) ? project.Info.title : ''}}
            <a @click.stop.prevent="openSteps()" class="questions" href="#"><font-awesome-icon :icon="['far', 'question-circle']" size="lg" /></a>
          </h1>
          <div v-if="validationMessages.length > 0" class="col-md-12">
            <h5>Projeto ainda possui dados pendentes. Verifique todos antes de publicá-lo.</h5>
            <div v-for="(validate, k) in validationMessages" v-bind:key="k" class="alert alert-danger alert-dismissible fade show" role="alert">
              {{validate.msg}}
            </div>
          </div>
        </div>
        <div id="form-project" class="row" :class="{'scrollable': scrollPosition > 280}">
            <b-tabs pills vertical v-model="currentTab" v-if="project" v-on:input="(index) => currentTab = index">
              <b-tab title="Informações" :active="infoActive" class="form-config">
                <template slot="title">
                  <span class="step-0">Informações</span>
                </template>
                <ProjectInfo :project="this.project" v-on:showloading="loading = true" v-on:hideloading="loading = false" v-on:reload="reloadProject()" :validated="this.isValidated"></ProjectInfo>

              </b-tab>

              <b-tab v-if="user.UserId == project.UserId || user.isAdmin" title="Gestor" class="form-config">
                <template slot="title">
                  <span class="step-5">Gestor</span>
                </template>
                <ProjectManager v-bind:project="this.project" v-on:showloading="loading = true" v-on:hideloading="loading = false" v-on:reload="reloadProject()"></ProjectManager>

              </b-tab>

              <b-tab v-if="user.UserId == project.UserId || user.isAdmin" title="Dados Bancários" class="form-config">
                <template slot="title">
                  <span class="step-6">Dados Bancários</span>
                </template>
                <ProjectBankInfo :project="this.project" v-on:showloading="loading = true" v-on:hideloading="loading = false" v-on:reload="reloadProject()"></ProjectBankInfo>

              </b-tab>

              <b-tab v-if="project && project.projectType != 'event' && (user.UserId == project.UserId || user.isAdmin)" title="Meios de Pagamento" class="form-config">
                <template slot="title">
                  <span class="step-8">Meios de Pagamento</span>
                </template>
                <ProjectOther v-bind:project="this.project" v-on:showloading="loading = true" v-on:hideloading="loading = false" v-on:reload="reloadProject()"></ProjectOther>

              </b-tab>

              <b-tab v-if="project && project.projectType != 'event' && (user.UserId == project.UserId || user.isAdmin)" class="form-config">
                <template slot="title">
                  <span class="step-1">Usuários</span>
                </template>

                <ProjectUsers v-bind:project="this.project" v-on:showloading="loading = true" v-on:hideloading="loading = false" v-on:reload="reloadProject()"></ProjectUsers>

              </b-tab>

              <b-tab title="Imagens" class="form-config">
                <template slot="title">
                  <span class="step-2">Imagens</span>
                </template>
                <ProjectImages v-bind:project="this.project" v-on:showloading="loading = true" v-on:hideloading="loading = false" v-on:reload="reloadProject()"></ProjectImages>

              </b-tab>

              <b-tab v-if="project && project.projectType != 'event'" title="Atividades" :active="activitiesActive" class="form-config">
                <template slot="title">
                  <span class="step-2">Atividades</span>
                </template>
                <ProjectActivities v-bind:project="this.project" v-on:showloading="loading = true" v-on:hideloading="loading = false" v-on:reload="reloadProject()"></ProjectActivities>

              </b-tab>

              <b-tab title="Doadores" class="form-config">
                <template slot="title">
                  <span class="step-3">Doadores</span>
                </template>
                <ProjectDonations v-bind:project="this.project" v-on:showloading="loading = true" v-on:hideloading="loading = false" v-on:reload="reloadProject()"></ProjectDonations>

              </b-tab>

              <b-tab v-if="project && project.projectType != 'event'" title="Custos" class="form-config">
                <template slot="title">
                 <span class="step-4">Custos</span>
                </template>
                <ProjectCosts v-bind:project="this.project" v-on:showloading="loading = true" v-on:hideloading="loading = false" v-on:reload="reloadProject()"></ProjectCosts>

              </b-tab>

              <b-tab v-if="user.UserId == project.UserId || user.isAdmin" title="Extrato" class="form-config">
                <template slot="title">
                  <span class="step-7">Extrato</span>
                </template>
                <ProjectExtract v-bind:project="this.project" v-on:showloading="loading = true" v-on:hideloading="loading = false" v-on:reload="reloadProject()"></ProjectExtract>

              </b-tab>

              <b-tab v-if="project && project.projectType != 'event'" title="Botão" class="form-config">
                <template slot="title">
                  <span class="step-9">Botão</span>
                </template>
                <ProjectButton v-bind:project="this.project" v-on:showloading="loading = true" v-on:hideloading="loading = false" v-on:reload="reloadProject()"></ProjectButton>

              </b-tab>

              <b-tab title="Mensagem" class="form-config">
                <template slot="title">
                  <span class="step-10">Mensagem</span>
                </template>
                <ProjectDonationMessage v-bind:project="this.project" v-on:showloading="loading = true" v-on:hideloading="loading = false" v-on:reload="reloadProject()"></ProjectDonationMessage>

              </b-tab>

              <b-tab v-if="project && project.projectType != 'event'" title="Métrica Social" class="form-config">
                <template slot="title">
                  <span class="step-11">Métrica Social</span>
                </template>
                <ProjectSocialMetrics v-bind:project="this.project" v-on:showloading="loading = true" v-on:hideloading="loading = false" v-on:reload="reloadProject()"></ProjectSocialMetrics>

              </b-tab>

              <b-tab v-if="project && project.projectType != 'event'" title="Métrica Social" class="form-config">
                <template slot="title">
                  <span class="step-11">Descontos do Bem</span>
                </template>
                <ProjectLinkDescontos v-bind:project="this.project" v-on:showloading="loading = true" v-on:hideloading="loading = false" v-on:reload="reloadProject()"></ProjectLinkDescontos>

              </b-tab>

            </b-tabs>
        </div>
      </div>

    </div>
    <Footer></Footer>
    <Loading v-if="loading"></Loading>
    <v-tour name="projectTour" :steps="steps" :options="stepOptions" :callbacks="stepsCallback"></v-tour>
  </div>
</template>

<script>

import Header from './includes/Header'
import Footer from './includes/Footer'
import Loading from './includes/Loading'
import auth from '../services/auth'
import Functions from '../utils/functions'
import { API } from '../services/api'
import ProjectInfo from './manage-project/Info';
import ProjectActivities from './manage-project/Activities';
import ProjectBankInfo from './manage-project/BankInfo';
import ProjectCosts from './manage-project/Costs';
import ProjectDonations from './manage-project/Donations';
import ProjectExtract from './manage-project/Extract';
import ProjectManager from './manage-project/Manager';
import ProjectOther from './manage-project/Other';
import ProjectButton from './manage-project/Button';
import ProjectSocialMetrics from './manage-project/SocialMetrics';
import ProjectLinkDescontos from './manage-project/LinkDescontos';
import ProjectDonationMessage from './manage-project/DonationMessage';
import ProjectUsers from './manage-project/Users';
import ProjectImages from './manage-project/Images';
import {VMoney} from 'v-money'
import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
import {faQuestionCircle} from '@fortawesome/fontawesome-free-regular'

export default {
  name: 'MyProjects',
  components: {
    Header,
    Footer,
    Loading,
    ProjectInfo,
    ProjectActivities,
    ProjectCosts,
    ProjectBankInfo,
    ProjectDonations,
    ProjectExtract,
    ProjectManager,
    ProjectOther,
    ProjectButton,
    ProjectDonationMessage,
    ProjectSocialMetrics,
    ProjectLinkDescontos,
    ProjectUsers,
    ProjectImages,
    FontAwesomeIcon
  },
  directives: {money: VMoney},
  data () {
    return {
      loading: true,
      project: false,
      infoActive: true,
      activitiesActive: false,
      currentTab: 0,
      validationMessages: [],
      isValidated: false,
      user: null,
      scrollPosition: null,
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        suffix: '',
        precision: 2,
        masked: false
      },
      stepOptions: {
        useKeyboardNavigation: false,
        labels: {
            buttonSkip: 'Fechar',
            buttonPrevious: 'Anterior',
            buttonNext: 'Próximo',
            buttonStop: 'Finalizar'
          }
      },
      steps: [
        {
          target: '.step-0',
          content: 'Complete as informações essenciais do seu projeto aqui. Cadastre uma foto, selecione categorias, entre outros detalhes.',
          offset: 200,
          params: {
            placement: 'top',
            enableScrolling: false
          }
        },
        {
          target: '.step-5',
          content: 'Defina as informações do gestor/responsável pelo projeto.',
          params: {
            placement: 'top',
            enableScrolling: false
          }
        },
        {
          target: '.step-6',
          content: 'Cadastre dados bancários para receber doações via boleto ou transferência direta.',
          params: {
            placement: 'top',
            enableScrolling: false
          }
        },
        {
          target: '.step-8',
          content: 'Configure sua conta PayPal para receber doações com cartão de crédito.',
          params: {
            placement: 'top',
            enableScrolling: false
          }
        },
        {
          target: '.step-1',
          content: 'Defina os usuários que poderão editar o seu projeto.',
          params: {
            placement: 'top',
            enableScrolling: false
          }
        },
        {
          target: '.step-2',
          content: 'Cadastre atividades relacionadas aos seus projetos. Os usuários que favoritarem irão receber informações quando forem publicadas.',
          params: {
            placement: 'top',
            enableScrolling: false
          }
        },
        {
          target: '.step-3',
          content: 'Visualize todos os doadores do projeto.',
          params: {
            placement: 'top',
            enableScrolling: false
          }
        },
        {
          target: '.step-4',
          content: 'Cadastre custos do projeto para que sirvam de referência para os doadores.',
          params: {
            placement: 'top',
            enableScrolling: false
          }
        },
        {
          target: '.step-7',
          content: 'Consulte o extrato das doações realizadas via boleto ou transferência direta.',
          params: {
            placement: 'top',
            enableScrolling: false
          }
        },
        {
          target: '.step-9',
          content: 'Compartilhe um botão no formato HTML que irá direcionar para a página do seu projeto.',
          params: {
            placement: 'top',
            enableScrolling: false
          }
        },
        {
          target: '.step-10',
          content: 'Defina uma mensagem de agradecimento para enviar aos doadores.',
          params: {
            placement: 'top',
            enableScrolling: false
          }
        },
        {
          target: '.step-11',
          content: 'Informe uma métrica social para calcular o valor das doações para os usuários.',
          params: {
            placement: 'top',
            enableScrolling: false
          }
        },
      ],
      stepsCallback: {
        onPreviousStep: this.onStepsPrevious,
        onNextStep: this.onStepsNext
      }
    }
  },
  created(){
    this.getProfile();
    if(this.$route.query.tab && this.$route.query.tab == 'activities'){
      this.infoActive = false;
      this.activitiesActive = true;
    }
  },
  mounted (){
    this.updateScroll()
    window.addEventListener('scroll', this.updateScroll)
  },
  methods: {
    getProfile(){
      this.$http.get(API.Profile.profile, {headers: auth.getHeaders()}).then((result) => {
        this.user = result.body.user;
        this.loadProject();
      }, (err) => {
        auth.logout();
        this.$router.push('/login');
      });
    },
    loadProject(){
      this.loading = true;
      this.$http.get(API.Projects.getPrivateProject + this.$route.params.slug, {headers: auth.getHeaders()}).then((res) => {
        if(res.body.success === true){
          this.project = res.body.project;
          this.loading = false;
          this.validate();
          this.$forceUpdate();
        }else{
          this.$router.go('/dashboard');
        }
      }, (err) => {
        console.log(err)
        this.$router.push('/dashboard');
      });
    },
    validate(){
      this.validationMessages = [];
      if(this.project){
        if(!this.project.Info.image && !this.project.Info.video){
          this.validationMessages.push({msg: 'Projeto não possui uma imagem ou vídeo.'});
        }
        if(!this.project.Info.description){
          this.validationMessages.push({msg: 'Projeto não possui uma descrição.'});
        }
        if(!this.project.PagarmeAccount || !this.project.PagarmeAccount.receiverId || !this.project.PagarmeAccount.bankAccountCode || !this.project.PagarmeAccount.bankAccountAgency
          || !this.project.PagarmeAccount.bankAccountAccount || !this.project.PagarmeAccount.bankAccountLegalName || !this.project.PagarmeAccount.bankAccountDocumentNumber){
          this.validationMessages.push({msg: 'Projeto não possui uma conta cadastrada nos dados bancários ou está com os dados incompletos.'});
        }
        if(!this.project.Manager || (this.project.Manager && (!this.project.Manager.name || !this.project.Manager.phone || !this.project.Manager.organization))){
          this.validationMessages.push({msg: 'Projeto não possui dados do gestor cadastrados.'});
        }
        if(!this.project.DonationMessage){
          this.validationMessages.push({msg: 'Projeto não possui mensagem de agradecimento cadastrada.'});
        }
        if(this.validationMessages.length == 0){
          this.isValidated = true;
        }
      }
    },
    openSteps(){
      this.$tours['projectTour'].start()
      var $this = this;
      setTimeout(function(){
        $this.$tours['projectTour'].currentStep = $this.currentTab
      }, 10)
    },
    onStepsPrevious(currentStep){
      this.currentTab = currentStep - 1;
    },
    onStepsNext(currentStep){
      this.currentTab = currentStep + 1;
    },
    reloadProject(){
      this.loadProject()
    },
    updateScroll(){
      this.scrollPosition = window.scrollY;
    }
  },
  beforeRouteLeave (to, from, next) {
    if(this.project){
      var r = confirm("Deseja sair desta tela? Alterações não salvas serão perdidas.");
      if(r == true){
        next();
      }
    }else{
      next();
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
h4{
  color: #00AE39;
  margin-bottom: 1px;
}
span{
  font-size: 15px;
}

#form-project{
  padding-bottom: 40px;
}

.questions{
  color: #00AE39;
  font-size: 24px;
  margin-left: 10px;
}

.form-config{
    .row{
      padding: 20px;
      border-bottom: thin solid #eee;
      &:last-child{
        border-bottom: none;
      }
    }
    .btn{
      font-size: 22px;
      color: #fff;
      background-color: #00AE39;
      &.clear-project{
        background-color: red;
      }
      &:hover{
        background-color: #aaa;
        color: #333;
      }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/ManageProject.vue